import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

export interface FeedItem {
  title: string;
  link: string;
  guid: string;
  publishedAt: string;
  description: string;
}

@Injectable({
  providedIn: 'root'
})
export class FeedService {
  private readonly API_URL = environment.apiUrl;
  private http = inject(HttpClient);

  getItems() {
    return this.http.get<FeedItem[]>(`${this.API_URL}/rest/feed/items`);
  }
}
